export default "__VITE_ASSET__CElKyLWe__"